var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{attrs:{"slot":"header"},domProps:{"innerHTML":_vm._s(_vm.caption)},slot:"header"}),_c('b-table',{attrs:{"dark":_vm.dark,"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"responsive":"sm","items":_vm.items,"fields":_vm.captions},scopedSlots:_vm._u([{key:"cell(status)",fn:function(ref){
var value = ref.value;
return [_c('b-badge',{attrs:{"variant":_vm.getBadge(value)}},[_vm._v(_vm._s(value))])]}},{key:"cell(fnsid)",fn:function(data){return [_c('a',{attrs:{"href":_vm.envVar +
            'tracker_private/includes/customerReportPublic.php?ftrack=' +
            data.value +
            '-' +
            data.item.fnsra}},[_vm._v(_vm._s(data.value))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }